import { cva } from 'class-variance-authority';

export const cvaProfileItemInner = cva([
  'ProfileItemStyles-cvaProfileItemInner',
  'relative',
  'flex justify-between items-center',
  'px-1.4 py-1.6',
]);

export const cvaProfileItemText = cva([
  'ProfileItemStyles-cvaProfileItemText',
  'relative',
  'text-l-b',
]);

export const cvaProfileItemProfit = cva([
  'ProfileItemStyles-cvaProfileItemInner',
  'text-l-b text-cGreen',
]);

export const cvaProfileItemCounter = cva([
  'ProfileItemStyles-cvaProfileItemCounter',
  'text-[1.3rem] text-white',
  'rounded-full bg-cGreen min-w-2.4 h-2.4',
  'absolute -top-2.2 -right-2',
  'flex items-center justify-center',
]);
